import React from 'react'
import Header from './Landingpage/Header.jsx';
import Footer from './Landingpage/footer.jsx';
import Landingpage from './Landingpage/landingPage/landinPage.jsx'
import States from './Landingpage/states/states.jsx'
import { Route } from 'react-router-dom'
import Cites from './Landingpage/cites/cites.jsx';
import CityInfo from './Landingpage/city info/cityInfo';
import Login from './Landingpage/auth/login.jsx';

import { useDispatch } from 'react-redux'
// GetUserAddress
import { GetUserAddress } from './redux/action/user'
import Selling from './Landingpage/Sell/Selling.jsx';


function HomeRouts({ ConnectToWallet, useraccount, contract }) {
  const dispatch = useDispatch()

  React.useEffect(() => {
    if (useraccount !== undefined && contract !== undefined) {



      dispatch(GetUserAddress(useraccount))
    }
  }, [useraccount, contract])



  return (
    <div>
      <Header />
      <Route exact path="/" > <Landingpage /></Route>
      <Route exact path="/login"><Login useraccount={useraccount} contract={contract} /></Route>
      <Route exact path="/states"> <States /></Route>
      <Route exact path="/cites/:country/:st/:stateIndex"><Cites /></Route>
      <Route exact path="/cites/:country/:st/:stateIndex/:cityName/:zip"><CityInfo useraccount={useraccount} contract={contract} /></Route>
      <Route exact path="/selling"> <Selling /></Route>
      <Footer ConnectToWallet={ConnectToWallet} />
    </div>
  )
}

export default HomeRouts